import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { EasypayEmployeeMapping } from './easypay-employee-mapping.interface';

import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EasypayEmployeeMappingService } from './easypay-employee-mapping.service';

const service = new EasypayEmployeeMappingService();

export interface EasypayEmployeeMappingState {
   easypayEmployeeMappingsOverview?: PaginatedResponse<EasypayEmployeeMapping>;
}

const EasypayEmployeeMappingStore: Module<EasypayEmployeeMappingState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_EASYPAY_EMPLOYEE_MAPPINGS_OVERVIEW: (state, overview: PaginatedResponse<EasypayEmployeeMapping>) =>
         (state.easypayEmployeeMappingsOverview = overview),
   },
   actions: {
      async getEasypayEmployeeMappings(context, query: LocationQuery) {
         return await service.getEasypayEmployeeMappings(query).then((response) => {
            context.commit('SET_EASYPAY_EMPLOYEE_MAPPINGS_OVERVIEW', response);
            return response;
         });
      },
   },
};

export default EasypayEmployeeMappingStore;
